import gql from 'graphql-tag';

export const EmailTemplateByNameQuery = gql`
  query($name: String!) {
    emailTemplate: allEmailTemplates(condition: { name: $name }) {
      nodes {
        id
        name
        content
      }
    }
  }
`;

export const presentationQuery = gql`
  query($name: String!) {
    presentationByName(name: $name) {
      id
      name
      url
      data
      cachedquery
      username
      active
      createdAt
      updatedAt
    }
  }
`;

export const updateQuery = gql`
  mutation($name: String!, $presentation: PresentationPatch!) {
    updatePresentationByName(
      input: { name: $name, presentationPatch: $presentation }
    ) {
      presentation {
        data
        url
        cachedquery
        username
        active
        updatedAt
      }
    }
  }
`;

export const deleteQuery = gql`
  mutation($id: Int!) {
    deletePresentationById(input: { id: $id }) {
      presentation {
        id
        name
        homePageUrl
        inventoryUrl
        fbPageId
        fbPageToken
        adAccountId
        adAccountToken
        active
      }
    }
  }
`;

export const submitRepository = gql`
  mutation($presentation: PresentationInput!) {
    createPresentation(input: { presentation: $presentation }) {
      presentation {
        name
        data
        url
        active
        username
        cachedquery
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/database/PresentationBuilderDB.js